import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import { Ga4 } from "@/lib/analytics";
import Home from "@/pages/Home";
import PaintingServices from "@/pages/PaintingServices";
import ServicePage from "@/pages/ServicePage";
import ServiceAreas from "@/pages/ServiceAreas";
import LocationPage from "@/pages/LocationPage";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Ga4 />
        <ScrollToTop />
        <Toaster richColors position="top-center" />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/painting-services" element={<PaintingServices />} />
            <Route
              path="/interior-painting"
              element={<ServicePage key="interior-painting" slug="interior-painting" />}
            />
            <Route
              path="/exterior-painting"
              element={<ServicePage key="exterior-painting" slug="exterior-painting" />}
            />
            <Route
              path="/drywall-repair"
              element={<ServicePage key="drywall-repair" slug="drywall-repair" />}
            />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/service-areas/:slug" element={<LocationPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
